export default {"src":"/_next/static/media/formationBanner1.ab2c8147.svg","height":71,"width":60,"blurWidth":0,"blurHeight":0};